<template>
  <div class="teamMembersWrapper">
    <div class="gridLayout">
      <div v-for="member in students" :key="member.user.id">
        <p>
          {{ member.user.first_name }}, {{ member.user.last_name }}
          <span id="projectRole">
            {{ mapUserRoleIntToString(member.user.id) }}
          </span>
        </p>
      </div>

      <h4 id="title" class="subTitle">{{ $t(localeConsts.supervisorTitle) }}</h4>
      <div v-for="member in supervisors" :key="member.user.id" class="supervisor">
        <p>{{ member.user.first_name }}, {{ member.user.last_name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { teamMembersMixin } from '../../../mixins/teamMembersMixin.js'
import axios from '@/axios'
import { generalHelperMethodsMixin } from '@/components/mixins/generalHelperMethodsMixin'
import { apiFetchMethodsMixin } from '@/components/mixins/apiFetchMethodsMixin'

export default {
  name: 'TeamMembersCardContent',
  mixins: [generalHelperMethodsMixin, mapGettersMixin, teamMembersMixin, apiFetchMethodsMixin],
  data() {
    return {
      fetchedData: [],
      students: [],
      supervisors: [],
      rawRoleAttributionHistory: [],
      roles: [],
      userCurrentRoleMap: {},
      localeConsts: {
        supervisorTitle: 'DASHBOARDCARD.SUPERVISORTITLE'
      }
    }
  },
  mounted() {
    Promise.all([this.fetchUserRoleAttributions(), this.fetchRoles()])
      .then(() => {
        this.determineCurrentRoles()
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.error('Error fetching user role attributions')
      })
  },
  methods: {
    async fetchUserRoleAttributions() {
      try {
        const responseProjectId = await this.getProjectId
        const params = {
          params: {
            project_id: responseProjectId
          }
        }
        const response = await axios.get('user-role-attributions', params)
        this.rawRoleAttributionHistory = response.data
        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    mapUserRoleIntToString(userId) {
      const roleId = this.userCurrentRoleMap[userId]

      if (roleId === undefined || !this.roles || this.roles.length === 0) {
        return ''
      }
      const roleObj = this.roles.find((r) => r.id === roleId)
      return roleObj ? `(${roleObj.label})` : ''
    },

    determineCurrentRoles() {
      const PROJECT_OWNER_ROLE_ID = 1
      const SCRUM_MASTER_ROLE_ID = 2

      let latestProjectOwner = { userId: null, date: null }
      let latestScrumMaster = { userId: null, date: null }

      for (const attribution of this.rawRoleAttributionHistory) {
        if (attribution.user && attribution.user.id && attribution.attribution_date) {
          const userId = attribution.user.id
          const attributionDate = new Date(attribution.attribution_date)

          if (attribution.user_role === PROJECT_OWNER_ROLE_ID) {
            if (!latestProjectOwner.date || attributionDate > latestProjectOwner.date) {
              latestProjectOwner = { userId, date: attributionDate }
            }
          }

          if (attribution.user_role === SCRUM_MASTER_ROLE_ID) {
            if (!latestScrumMaster.date || attributionDate > latestScrumMaster.date) {
              latestScrumMaster = { userId, date: attributionDate }
            }
          }
        }
      }

      const finalUserRoleMap = {}
      if (latestProjectOwner.userId) {
        finalUserRoleMap[latestProjectOwner.userId] = PROJECT_OWNER_ROLE_ID
      }
      if (latestScrumMaster.userId) {
        finalUserRoleMap[latestScrumMaster.userId] = SCRUM_MASTER_ROLE_ID
      }
      this.userCurrentRoleMap = finalUserRoleMap
    }
  }
}
</script>

<style>
.gridLayout {
  display: grid;
}

.subTitle {
  padding-top: 10px;
  grid-row: 4;
}

#projectRole {
  font-size: 12px;
  color: purple;
  display: block;
}

.supervisor {
  grid-row: 6;
}
</style>
